const WARNING_LIGHTS_ROOT_TOPIC_TITLES = ['icon glossary', 'warning & indicator lights']

export function getRootTopicForWarningLightsPublication(topics, publications) {
  const warningLightsPublication = publications?.find(publication => {
    return publication.get('publicationType') === 'WL' || publication.get('publicationSubType') === 'Icon Glossary'
  })
  const warningLightsPublicationId = warningLightsPublication.get('id')
  return topics.find(topic => {
    return topic.get('publication').get('publicationId') === warningLightsPublicationId && isWarningLightsRootTopic(topic.get('title'))
  })
}

/**
 * @param {string} title
 * @returns {boolean}
 */
export function isWarningLightsRootTopic(title) {
  return WARNING_LIGHTS_ROOT_TOPIC_TITLES.includes(title.toLowerCase())
}
